/**
 * Kapil 10/30: "Median via RM: $Y/person" only when the median is above the
 * lowest amount the member can pick for this request (the guaranteed-spend
 * list's first choice: the restaurant's minimum for that day and time). A $200
 * median under a $500 minimum (The Corner Store) is no help. RM AI and RM via
 * Text follow the same rule on the server (toolExecutor `spendMedianLine`).
 *
 * @param {number|null} median per person
 * @param {Array<{ value: number }>} options the guaranteed-spend choices
 * @returns {boolean}
 */
export function showMedianSpend(median, options) {
  const m = Number(median)
  if (!(m > 0)) return false
  const values = (options || []).map(o => Number(o?.value)).filter(v => v > 0)
  if (!values.length) return false

  return m > Math.min(...values)
}
